export default {"src":"/_next/static/media/moonshots.7610702a.svg","height":102,"width":474,"blurWidth":0,"blurHeight":0};